export default __webpack_public_path__ + "static/media/speedometer-3-selected.bc3db954.svg";